import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function HomeHero() {
  const { t } = useTranslation();
  function scrollToSection() {
    document
      .getElementById('downloadApp')
      .scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <section className="home__hero">
      <div className="home__hero-container">
        <h1>{t('home.title')}</h1>
        <p>{t('home.description')}</p>
        <button type="link" onClick={scrollToSection}>
          {t('home.button')}
        </button>
      </div>
    </section>
  );
}
